import React, { useState, useContext } from 'react';
import { AppContext } from '../../App';
import CheckSuccess from "../../icons/check.svg";
import './UserMenu.styles.scss';
import http from "../../core/http";

function UserMenu() {
    const {
        userName = 'Guest',
        isAuthorized,
        isUserMenuOpened,
        setIsLoginModalActive,
        credentials,
        isHelpPopupOpened,
        setIsHelpPopupOpened,
    } = useContext(AppContext);

    const [isContactSuccessful, setIsContactSuccessful] = useState(false);

    const handleClickContact = () => {
        setIsHelpPopupOpened(true);
        setIsContactSuccessful(true);
        http.auth('default/assistance-email-send');
        setTimeout(() => {
            setIsContactSuccessful(false);
        }, 5000)
    };

    return (
        <div className={`user-menu ${isUserMenuOpened ? 'user-menu--opened' : ''}`}>
            <div className="user-menu__inn">
                <div className="user-menu__top">
                    <div className="user-menu__name">{userName}{/* <br/>(access level {credentials.permissionLevel})*/}</div>
                </div>
                <div className="user-menu__bottom">
                        {isAuthorized ? (
                            <div className="user-menu__btns">
                                {isContactSuccessful ? (
                                    <div className="user-menu__contact">
                                        <div className="success-icon"><CheckSuccess /></div>
                                        Success
                                    </div>
                                ) : (
                                    <button
                                        className="btn btn--primary btn--small"
                                        onClick={handleClickContact}
                                    >
                                        Help
                                    </button>
                                )}
                                <a
                                    href={process.env.REACT_APP_LOGOUT}
                                    className="btn btn--log"
                                >
                                    Log out
                                </a>
                            </div>
                        ) : (
                            <div className="user-menu__btn">
                                <button
                                    className="btn btn--log"
                                    onClick={() => setIsLoginModalActive(true)}
                                >
                                    Log In
                                </button>
                            </div>
                        )}
                </div>
            </div>
        </div>
    );
}

export default UserMenu;